import React from 'react';

import { useNavigate } from 'react-router-dom';

import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';
import Jumbotron from '@/components/ui/box/Jumbotron';
import JumbotronButtonArea from '@/components/ui/box/JumbotronButtonArea.tsx';
import JumbotronDescription from '@/components/ui/box/JumbotronDescription.tsx';
import JumbotronPanel from '@/components/ui/box/JumbotronPanel.tsx';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle.tsx';
import Button from '@/components/ui/buttons/Button.tsx';
import ForParentsAppInformation from '@/features/registration/components/ForParentsAppInformation.tsx';

import styles from './AccountRegistrationCompletePage.module.scss';

const AccountRegistrationCompletePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <SingleColumnTemplate>
      <div className={styles.page}>
        <Jumbotron>
          <JumbotronPanel panelHeaderTitle="本登録完了">
            <div className={styles.panelContent}>
              <JumbotronTitle>アカウントの本登録が完了しました</JumbotronTitle>
              <JumbotronDescription>
                「マイページ」ボタンより
                <br />
                アカウント情報をご確認ください。
              </JumbotronDescription>
              <JumbotronButtonArea>
                <Button
                  onClick={() => navigate('/mypage/profile')}
                  size="m"
                  color="primary"
                >
                  マイページへ
                </Button>
              </JumbotronButtonArea>
              <hr />
              <ForParentsAppInformation />
            </div>
          </JumbotronPanel>
        </Jumbotron>
      </div>
    </SingleColumnTemplate>
  );
};

export default AccountRegistrationCompletePage;
